
$(".collection__filter__overlay").on("click", function () {
  console.log("ON CLICK FILTER");
  $(".drawer__button.drawer__close.collection__filter_close").click();
});


window.upcartOnCartLoaded = updateCartLoaded;

function updateCartLoaded() {
  $("#UpcartPopup").attr("data-aioseo-ignore", true);
  replaceWithParagraph("#UpcartPopup h3");
  replaceWithParagraph("#UpcartPopup h2");
}

function replaceWithParagraph(elem) {
  var h3 = $(elem);
  var paragraph = $("<p>").html(h3.html());
  $.each(h3[0].attributes, function() {
    if (this.specified) {
      paragraph.attr(this.name, this.value);
    }
  })

  h3.replaceWith(paragraph);
}

setTimeout(() => {
  updateCartLoaded();
}, 1500);

// Trigger klaviyo pop up form on click
document.querySelector('.announcement__bar').addEventListener('click', function (){
  window._klOnsite = window._klOnsite || []; 
  window._klOnsite.push(['openForm', 'U97Rub']);
});

// document.querySelector('.announcement__bar').addEventListener('click', function (){
//   alert('testing');  
// });